<template>
	<nav>
		<img :src="bgNav">
		<el-menu :unique-opened="true" router :default-active="defaultSelect">
			<template v-for="(item,key) in menu">
				<template v-if="item.child">
					<el-submenu :index="key">
						<template slot="title">{{item.name}}</template>
						<el-menu-item-group>
							<template v-for="(i,k) in item.child">
								<el-menu-item :index="k"><i v-if="i.icon" :class="i.icon"></i>{{i.name}}</el-menu-item>
							</template>
						</el-menu-item-group>
					</el-submenu>
				</template>
				<template v-else>
					<el-menu-item :index="key">{{item.name}}</el-menu-item>
				</template>
			</template>
		</el-menu>
	</nav>
</template>

<script>
	export default {
		name: 'nav',
		data() {
			return {}
		},
		//计算数据
		computed: {
			defaultSelect:function(){
				return this.$route.path;
			}
		},
		//参数数据
		props: {
			bgNav: {},
			menu: {},
		},
		//方法
		methods: {
		},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import url("../assets/common.less");
	nav {
		img {
			width: 100%;
			margin-bottom: 3px;
		}
		.el-menu {
			background-color: #fbfbfb;
			.el-submenu {
				.el-menu {
					background-color: #fbfbfb;
				}
			}
			i.iconfont {
				margin-right: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// nav-menu.vue?30e5245d